export default function formAPIhistoryofpresentillness({
    appointmentid,
    details,
    doctorname,
    imagepath,
    patientid,
    profilepictureurl,
    specialization,
    type,
    bookingid,
    appointmentdate,
    iscurrentvisit,
    updatedby,
    updatedbyid,
    updateddate,
    summary,
    id,
    doctorid

})
{
  return Object.freeze({
    appointmentid,
    details,
    doctorname,
    imagepath,
    patientid,
    profilepictureurl,
    specialization,
    type,
    bookingid,
    appointmentdate,
    iscurrentvisit,
    updatedby,
    updatedbyid,
    updateddate,
    summary,
    id,
    doctorid
   
  });
}